import { makeStyles, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import GalleryPopup from 'components/molecules/gallery/GalleryPopup';
import SideNavigation from 'components/molecules/navigation/SideNavigation';
import Header from 'components/organisms/Header';
import { ErrorContext } from 'context/error/ErrorContext';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Gallery from 'routes/Gallery';
import { AuthContext } from './context/auth/AuthContext';
import Homepage from './routes/Homepage';
import Login from './routes/Login';

const useStyles = makeStyles(() => ({
    content: {
        display: 'grid',
        gridTemplateColumns: '75px auto',
    },
    pages: {
        padding: '0 30px',
    },
}));

const Routes: React.FC = () => {
    const classes = useStyles();
    const { state: errorState, setErrorState } = useContext(ErrorContext);

    return (
        <Router>
            <AuthContext.Consumer>
                {(value) =>
                    value?.state?.isAuthenticated ? (
                        <>
                            <Header />
                            <main className={classes.content}>
                                <SideNavigation />

                                <div className={classes.pages}>
                                    <Switch>
                                        <Route path='/login'>
                                            <Login />
                                        </Route>
                                        <Route path='/gallery'>
                                            <Gallery />
                                        </Route>
                                        <Route path='/'>
                                            <Homepage />
                                        </Route>
                                    </Switch>
                                </div>
                            </main>
                            // Global dispatch for error handling, this provides a popup in the middle of the screen
                            showing an error message.
                            <Snackbar
                                open={errorState.hasError}
                                onClose={() => setErrorState({ ...errorState, hasError: false })}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                key={Date.now()}
                            >
                                <Alert
                                    onClose={() => setErrorState({ ...errorState, hasError: false })}
                                    severity='error'
                                >
                                    {errorState.message}
                                </Alert>
                            </Snackbar>
                            // This popup is here so it can be accessed by any component that needs access to the
                            gallery
                            <GalleryPopup />
                        </>
                    ) : (
                        <Login />
                    )
                }
            </AuthContext.Consumer>
        </Router>
    );
};

export default Routes;
